<template>
  <div>
    <vs-popup
      :title="$t('AgentProductsSegment') + agentName"
      :active.sync="showModal"
    >
      <!-- add form -->
      <form>
        <div class="vx-row">
          <div class="vx-col sm:w-5/6 w-full mb-2">
            <label class="vs-select--label">{{ $t("Contract") }}</label>

            <v-select
              label="title"
              :options="allContracts"
              :reduce="x => x.id"
              v-model="agentSegmentInfo.contractId"
              ref="contractSelectList"
              dir="rtl"
              :key="inputsKey"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col lg:w-5/6 w-full">
            <label class="vs-select--label">{{ $t("ProductSegment") }}</label>

            <v-select
              label="name"
              v-model="agentSegmentInfo.segmentId"
              :options="segments"
              :reduce="x => x.id"
              ref="productSegment"
              dir="rtl"
              :key="inputsKey"
            />
          </div>

          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn"
              @click.prevent="assignSegment"
            />
          </div>
        </div>
      </form>

      <!-- grid (بدون تغییر) -->
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('ProductSegment') },
          { title: $t('Contract') },
          { title: $t('Action') }
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 40%">
            {{ row.name }}
          </td>

          <td style="width: 40%">
            {{ row.contractTitle }}
          </td>

          <td style="width: 17%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="unassignSegment(row)"
              class="d-inline"
            />
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.add-btn {
  margin-top: 1.5rem;
}

.vs-popup--content {
  overflow-y: scroll !important;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "@/components/CustomVSelect.vue";

export default {
  name: "saleManagement_SalesPersons_AgentSegmentPopup",

  props: {
    show: { default: false },
    agentId: { default: "" },
    agentName: { default: "" }
  },

  data() {
    return {
      gridDataSource: { data: [] },
      gridSearchData: {},

      unassignModel: {},

      agentSegmentInfo: {},
      segments: [],
      inputsKey: 0
    };
  },

  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("finish");
      }
    },

    ...mapGetters({
      allContracts: "sale/listContract"
    })
  },

  mounted() {
    this.fetchContract();

    this.getSegments().then(response => {
      if (!response.success) {
        this.segments = response;
      }
    });
  },

  methods: {
    ...mapActions({
      fetchContract: "sale/fetchContractList",
      assignAgentSegment: "productSegment/assignAgentSegment",
      unassignAgentSegment: "productSegment/unassignAgentSegment",
      getSegments: "productSegment/getAllSegments"
    }),

    assignSegment() {
      this.agentSegmentInfo.agentId = this.agentId;

      this.assignAgentSegment(this.agentSegmentInfo).then(() => {
        this.agentSegmentInfo = {};

        this.$vs.notify({
          title: "عملیات موفق",
          text: "رکورد مورد نظر با موفقیت اضافه شد!",
          color: "success"
        });

        this.$refs.grid.renderGrid();
      });

      this.inputsKey++;
    },

    unassignSegment(model) {
      this.unassignModel = {};

      this.unassignModel = {
        agentId: this.agentId,
        segmentId: model.segmentId,
        contractId: model.contractId,
        salePersonId: model.salePersonId
      };

      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.unassignAgentSegment(this.unassignModel).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.agentSegmentInfo = {};

        this.gridDataSource = {
          type: "app",
          service:
            "Sales/api/SaleAgentsQuery/" +
            this.agentId +
            "/get-all/salePersonId/segmentInfos"
        };

        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 100);
      }
    }
  },

  components: {
    DataGrid,
    "v-select": vSelect
  }
};
</script>
